// extracted by mini-css-extract-plugin
module.exports = {"c15omtcn":"c15omtcn"};